/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Sales_Return_History_RefundedInputs */

const vi_sales_return_history_refunded = /** @type {(inputs: Sales_Return_History_RefundedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã hoàn ${i?.amount}`)
};

/**

* @param {Sales_Return_History_RefundedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_history_refunded = /** @type {((inputs: Sales_Return_History_RefundedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_History_RefundedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_history_refunded(inputs)
});